import { zodValidator } from '@tanstack/zod-adapter';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { TemplateCatalogPage } from '../features/templates/template-catalog-page';
import { ProjectStyleGallery } from '../features/templates/project-style-gallery';

const SearchSchema = z.object({
  category: z.string().trim().max(80).optional().catch(undefined),
  page: z.number().int().positive().catch(1),
  pageSize: z.union([z.literal(10), z.literal(25), z.literal(50), z.literal(100)]).catch(25),
  search: z.string().trim().max(200).optional().catch(undefined),
  tab: z.enum(['templates', 'styles']).optional().catch(undefined),
  projectId: z.string().max(100).optional().catch(undefined),
  style: z
    .string()
    .regex(/^[a-z][a-z0-9-]*@[1-9][0-9]*$/)
    .max(100)
    .optional()
    .catch(undefined),
});
export const Route = createFileRoute('/manage/$companySlug/templates')({
  component: RouteComponent,
  validateSearch: zodValidator(SearchSchema),
});
function RouteComponent() {
  const { companySlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const validProjectId = z.uuid().safeParse(search.projectId);
  const projectId = validProjectId.success ? validProjectId.data.toLowerCase() : undefined;
  return (
    <>
      {search.tab === 'styles' ? (
        <ProjectStyleGallery
          key={companySlug}
          companySlug={companySlug}
          projectId={projectId}
          invalidProject={search.projectId !== undefined && !validProjectId.success}
          selectedStyleId={search.style}
          onProjectChange={(id) =>
            void navigate({
              search: (previous) => ({ ...previous, projectId: id, style: undefined }),
            })
          }
          onSelectedStyleChange={(id) =>
            void navigate({ search: (previous) => ({ ...previous, style: id }) })
          }
        />
      ) : (
        <TemplateCatalogPage
          companySlug={companySlug}
          category={search.category}
          onCategoryChange={(category) =>
            void navigate({
              replace: true,
              search: (previous) => ({ ...previous, category, page: 1 }),
            })
          }
          onPageChange={(page) => void navigate({ search: (previous) => ({ ...previous, page }) })}
          onSearchChange={(value) =>
            void navigate({
              replace: true,
              search: (previous) => ({ ...previous, page: 1, search: value }),
            })
          }
          {...search}
        />
      )}
    </>
  );
}
